import { defineSlotRecipe } from '@chakra-ui/react';
import { radioGroupAnatomy } from '@chakra-ui/react/anatomy';

export default defineSlotRecipe({
  slots: radioGroupAnatomy.keys(),
  base: {
    itemControl: {
      bg: 'white',
      borderColor: 'gray.300',
      transition: 'all 250ms',
    },
    itemText: {
      fontWeight: 'light',
      lineHeight: '1',
    },
  },
  variants: {
    sizes: {
      lg: {
        itemControl: {
          h: 6,
          w: 6,
        },
      },
    },
  },
});
